import { useState, type FormEvent } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AuthField } from "@/components/AuthForm";
import { api, formatApiError } from "@/lib/api";

export function ForgotPasswordDialog() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try { setMsg((await api.post<{ message: string }>("/auth/forgot-password", { email })).data.message); }
    catch (err) { setMsg(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog onOpenChange={(o: boolean) => { if (!o) { setMsg(""); setEmail(""); } }}>
      <DialogTrigger asChild>
        <button type="button" className="text-[13px] font-semibold text-[#2C4F91] hover:text-[#16294D] hover:underline" data-testid="forgot-password-link">¿Olvidaste tu contraseña?</button>
      </DialogTrigger>
      <DialogContent className="bg-white sm:max-w-md" data-testid="forgot-password-dialog">
        <DialogHeader>
          <span className="mb-2 flex h-10 w-10 items-center justify-center rounded-lg bg-[#DFE7F3] text-[#16294D]"><KeyRound className="h-5 w-5" /></span>
          <DialogTitle className="font-display text-xl text-[#1B2A4A]">Recupera tu contraseña</DialogTitle>
          <DialogDescription>Te mandamos un enlace de un solo uso que vence en 1 hora.</DialogDescription>
        </DialogHeader>
        {msg ? <p className="text-sm text-slate-600" data-testid="forgot-password-message">{msg}</p> : (
          <form onSubmit={submit} className="space-y-4">
            <AuthField id="forgot-email" label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" />
            <Button type="submit" disabled={busy || !email} className="h-11 w-full bg-[#1B2A4A] text-white hover:bg-[#2A3D63]" data-testid="forgot-password-submit">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enviar enlace"}
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
